import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import HeaderComponent from "@/components/HeaderComponent.vue";
import SeeMoreButton from "@/components/SeeMoreButton.vue";
import GameIntro from "@/components/GameIntro.vue";
import CopyRight from "@/components/CopyRight.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SeeMoreButton),
    _createVNode(HeaderComponent),
    _createVNode(GameIntro),
    _createVNode(CopyRight, { class: "copyright" })
  ], 64))
}
}

})